import axios from "axios";
import { Utils } from "./utils";
const MEMBER_ROLE_TYPE = "member";
const OWNER_ROLE_TYPE = "owner";
const SHARED_USER_ROLE_TYPE = "shared user";
const BASE_URL = `${process.env.REACT_APP_API_BASE_URL}`;
export class Permissions {
  static hasService(membershipsOld, moduleToCheck, organizationId) {
    let memberships = membershipsOld;
    let access = false;
    if (!memberships || !moduleToCheck) {
      return { access };
    }
    memberships = memberships.filter(
      (membership) =>
        Number(membership.organizationId) === Number(organizationId)
    );

    memberships.forEach((membership) => {
      const { services } = membership;
      const { role } = membership;
      const roleToLowerCase = role ? role.toLowerCase() : role;

      const service = services.filter(
        (service) =>
          service?.displayName === moduleToCheck &&
          service.active === true &&
          (roleToLowerCase === MEMBER_ROLE_TYPE ||
            roleToLowerCase === OWNER_ROLE_TYPE ||
            roleToLowerCase === SHARED_USER_ROLE_TYPE)
      );

      access = service.length > 0;
      return { access };
    });
    return { access };
  }

  static checkMenuItemPermissions(pages) {
    const MenuNames = [];
    if (!pages) {
      return [];
    }
    for (let i = 0; i <= pages.length - 1; i++) {
      if (pages[i].permissions > 0) {
        MenuNames.push(pages[i].displayName);
      }
    }
    const MenuItems = Utils.getMenuItems(MenuNames);
    return MenuItems;
  }

  static checkMenuItemPermissionsWithRole(pages, role) {
    console.log(role);
    const MenuNames = [];
    for (let i = 0; i <= pages.length - 1; i++) {
      if (pages[i].permissions > 0) {
        MenuNames.push(pages[i].displayName);
      }
      // else if (pages[i].displayName === 'Account Management') {
      // 	role === 'owner' && MenuNames.push(pages[i].displayName);
      // }
    }

    const MenuItems = Utils.getMenuItems(MenuNames);
    return MenuItems;
  }
  static getModulePermissions = (serviceId, userId, organizationId) => {
    const url = `${BASE_URL}/authenticate/permission`;
    const params = { serviceId, userId, organizationId };
    const config = {
      withCredentials: true,
      headers: { "Content-Type": "application/json" },
    };

    return axios.post(url, params, config);
  };
  static getUserModulePermissions = (serviceId, userId, organizationId) => {
    const url = `${BASE_URL}/authenticate/permissions`;
    const params = { serviceId, userId, organizationId };
    const config = {
      withCredentials: true,
      headers: { "Content-Type": "application/json" },
    };

    return axios.post(url, params, config);
  };
  static updateComponentPermissions = (params) => {
    const url = `${BASE_URL}/authenticate/permission/update`;
    const config = {
      withCredentials: true,
      headers: { "Content-Type": "application/json" },
    };

    return axios.post(url, params, config);
  };

  static updateModulePermissions = (params, userId) => {
    const url = `${BASE_URL}/authenticate/permission/user/${userId}`;
    const config = {
      withCredentials: true,
      headers: { "Content-Type": "application/json" },
    };

    return axios.post(url, params, config);
  };
  static getUserMemberships = (userId, orgId) => {
    const url = `${BASE_URL}/authenticate/memberships/${orgId}/${userId}`;
    const config = {
      withCredentials: true,
      headers: { "Content-Type": "application/json" },
    };

    return axios.get(url, config);
  };

  static checkComponentAccess = (pagePermissions, pageName, componentName) => {
    const permissions = pagePermissions?.permissions;
    if (!permissions) {
      return false;
    }
    const PageToCheck = permissions.filter(
      (page) => page.displayName === pageName
    );
    let access = false;
    if (PageToCheck.length > 0) {
      const { components } = PageToCheck[0];
      const componentToCheck = components.filter(
        (component) => component.name === componentName
      );
      if (componentToCheck[0]) {
        access = componentToCheck[0].access >= 1;
      } else {
        access = false;
      }
    }
    return access;
  };

  static checkComponentAccessPermssions = (
    permissions,
    pageName,
    componentName
  ) => {
    if (!permissions) {
      return false;
    }
    const PageToCheck = permissions.filter(
      (page) => page.displayName === pageName
    );
    let access = false;
    if (PageToCheck.length > 0) {
      const { components } = PageToCheck[0];
      const componentToCheck = components.filter(
        (component) => component.name === componentName
      );
      if (componentToCheck[0]) {
        access = componentToCheck[0].access >= 1;
      } else {
        access = false;
      }
    }
    return access;
  };
}
